import { ICreateCredentialsContext } from './createCredentialsContext';

export enum CreateCredentialsActionTypes {
	CHANGE_CREDENTIAL_NAME = 'CHANGE_CREDENTIAL_NAME',
	CHANGE_API_KEY = 'CHANGE_API_KEY',
	CHANGE_API_SECRET = 'CHANGE_API_SECRET',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeCredentialName {
	type: CreateCredentialsActionTypes.CHANGE_CREDENTIAL_NAME;
	payload: {
		credentialName: ICreateCredentialsContext['credentialName'];
	};
}

interface IChangeApiKey {
	type: CreateCredentialsActionTypes.CHANGE_API_KEY;
	payload: {
		apiKey: ICreateCredentialsContext['apiKey'];
	};
}

interface IChangeApiSecret {
	type: CreateCredentialsActionTypes.CHANGE_API_SECRET;
	payload: {
		apiSecret: ICreateCredentialsContext['apiSecret'];
	};
}

interface ISetDataForSubmit {
	type: CreateCredentialsActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateCredentialsContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateCredentialsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateCredentialsContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: CreateCredentialsActionTypes.RESET_FIELDS;
}

export type TCreateCredentialsAction =
	| IChangeCredentialName
	| IChangeApiKey
	| IChangeApiSecret
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
